import { render, staticRenderFns } from "./JoinplatformModal.vue?vue&type=template&id=869716d4&scoped=true"
import script from "./JoinplatformModal.vue?vue&type=script&lang=js"
export * from "./JoinplatformModal.vue?vue&type=script&lang=js"
import style0 from "./JoinplatformModal.vue?vue&type=style&index=0&id=869716d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869716d4",
  null
  
)

export default component.exports